import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicFieldComponent } from './dynamic-field/dynamic-field.component';
import {ReactiveFormsModule} from "@angular/forms";
import {NgSelectModule} from "@ng-select/ng-select";
import {CoreModule} from "../../core/core.module";

@NgModule({
  declarations: [DynamicFieldComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    CoreModule
  ],
  exports: [
      DynamicFieldComponent
  ]
})
export class DynamicFormModule { }
